import React, { Component } from 'react';
import Banner from '../../components/Banner';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Link from 'react-router-dom/Link';
import DynamicPage from '../../components/DynamicPage';
import { URL } from '../../components/BackendApi';

class CoursePaymentCancelPage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, dynamicData: null };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const sessionId = params.get('id');

    // Update payment status
    if (sessionId) {
      fetch(`${URL}/courses/public/payment/cancel?id=${sessionId}`)
        .catch(() => {});
    }

    // Try to load dynamic page content
    fetch(`${URL}/pages/content_blocks?url=${encodeURIComponent('/koulutus/maksu/peruutettu')}`)
      .then(response => {
        if (!response.ok) throw new Error('No dynamic content');
        return response.json();
      })
      .then(data => {
        if (data.content_blocks && data.content_blocks.length > 0) {
          this.setState({ dynamicData: data, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="page">
          <Banner><h1>Maksu peruutettu</h1></Banner>
          <Container className="p-t-50 p-b-50 text-center">
            <p>K&auml;sitell&auml;&auml;n...</p>
          </Container>
        </div>
      );
    }

    if (this.state.dynamicData) {
      return <DynamicPage data={this.state.dynamicData} />;
    }

    return (
      <div className="page">
        <Banner><h1>Maksu peruutettu</h1></Banner>
        <Container className="p-t-50 p-b-50 text-center">
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Maksu peruutettu</h2>
              <p>Maksusi on peruutettu. Paikkavarauksesi on vapautettu.</p>
              <p>
                <Link to="/">Palaa etusivulle</Link>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CoursePaymentCancelPage;
